module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Negru1.91850240.jpg";